import React, { useState } from 'react';
import './featuredEvent.scss';
import '../pages/index.scss';
import '../../node_modules/slick-carousel/slick/slick.css';
import '../../node_modules/slick-carousel/slick/slick-theme.css';
import Img from 'gatsby-image';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { useLocation } from '@reach/router';
import { eventData } from '../data/StrapiEvent';
import { StrapiFeatured } from '../data/StrapiFeatured';
import { useEventSubscriptionHandler } from '../commons/hooks/ctaHandlers';
import EventTags from '../commons/EventTags';
import twitterIcon from '../assets/twitter.svg';
import linkedInIcon from '../assets/linkedin_article.svg';
import facebookIcon from '../assets/facebook_article.svg';
import Speaker from '../commons/Speaker';
import slugIt from '../utils/slugIt';

interface PropsFeaturedEvent {}

interface PropsEventDetails {
  title?: string | JSX.Element;
  details?: string | JSX.Element;
  className?: string;
}

export const EventDetails: React.FC<PropsEventDetails> = ({
  details,
  title,
  children,
  className,
}) => {
  return (
    <div className={`eventDetailsContainer ${className}`}>
      <h5>{title}</h5>
      <h4>{details}</h4>
      {children}
    </div>
  );
};

interface EventCardProps {
  event: eventData;
  social?: JSX.Element;
}

export const EventCard: React.FC<EventCardProps> = ({ event }) => {
  const [emailAddress, setEmailAddress] = useState('');
  const { pathname } = useLocation();

  const { status, updateFn, setStatus, loading } = useEventSubscriptionHandler(event, emailAddress);

  const { name, date, banner, shortDescription } = event;

  return (
    <div className="event">
      <div className="eventInner">
        <div className="eventLeft">
          <EventTags
            eventTime={date}
            isHardcoded={name.includes('High Performance GraphDBs & Use Cases')}
            isBlockchainEvent={name.includes('Blockchain')}
          />
          <h2>{name}</h2>
          <p className="eventLeftDescription">{shortDescription}</p>
          <Link to={`/events/${slugIt(name)}`}>Read more</Link>
          <Speaker
            profileImage={event.event_speaker.profileImage.childImageSharp.fluid}
            twitterURL={event.event_speaker.twitterHandle}
            description={event.event_speaker.description}
            speakerName={event.event_speaker.name}
          />
          <EventDetails
            title="Share"
            details={
              <div style={{ display: 'flex' }}>
                <div
                  style={{ cursor: 'pointer', marginRight: 20 }}
                  onClick={() =>
                    window.open(
                      `http://twitter.com/share?text=${name}&url=${
                        process.env.GATSBY_TWITTER_URL_PREFIX
                      }/fourthact/events/${slugIt(name)}`,
                      '_blank',
                    )
                  }
                >
                  <img src={twitterIcon} height="22px" alt="twitter-icon" />
                </div>
                <div
                  style={{ cursor: 'pointer', marginRight: 20 }}
                  onClick={() =>
                    window.open(
                      `https://www.linkedin.com/shareArticle?url=${
                        process.env.GATSBY_TWITTER_URL_PREFIX
                      }/fourthact/events/${slugIt(name)}&title=${name}`,
                      '_blank',
                    )
                  }
                >
                  <img src={linkedInIcon} height="22px" alt="linkedin-icon" />
                </div>
                <div
                  style={{ cursor: 'pointer', marginRight: 10 }}
                  onClick={() =>
                    window.open(
                      `http://www.facebook.com/sharer.php?u=${
                        process.env.GATSBY_TWITTER_URL_PREFIX
                      }/fourthact/events/${slugIt(name)}${pathname}`,
                      '_blank',
                    )
                  }
                >
                  <img src={facebookIcon} height="22px" alt="facebook-icon" />
                </div>
              </div>
            }
          />
        </div>
        <div className="eventRight">
          <div className="eventLeftImgContainer">
            <Img style={{ height: 'fit-content' }} fluid={banner.childImageSharp.fluid} />
          </div>
        </div>
      </div>
      {loading && (
        <div className="eventCTAContainer eventCTAContainerLoading">
          <h4>Loading...</h4>
        </div>
      )}
      {status === 'initial' && !loading && (
        <div className="eventCTAContainer">
          <h3>Request an Invite</h3>
          <form onSubmit={updateFn} className="eventCTAContainerForm">
            <input
              onChange={(event) => setEmailAddress(event.target.value)}
              placeholder="Enter your LinkedIn email"
            />
            <button onClick={updateFn} className="buttonPrimaryTeal">
              Submit
            </button>
          </form>
        </div>
      )}
      {status === 'success' && (
        <div className="eventCTAContainer eventCTAContainerSuccess">
          <h3>Your request has been registered!</h3>
        </div>
      )}
      {status === 'error' && (
        <div className="eventCTAContainer eventCTAContainerError">
          <h3>There was an error!</h3>
          <button onClick={() => setStatus('initial')} className="buttonSecondaryTeal">
            Try Again
          </button>
        </div>
      )}
    </div>
  );
};

const FeaturedEvent: React.FC<PropsFeaturedEvent> = () => {
  const featuredEventsData: StrapiFeatured = useStaticQuery(graphql`
    {
      allStrapiFeatured {
        edges {
          node {
            events {
              id
              type
              name
              description
              date
              eventUrl
              shortDescription
              event_speaker {
                description
                name
                twitterHandle
                profileImage {
                  childImageSharp {
                    fluid(maxWidth: 50, maxHeight: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
              banner {
                childImageSharp {
                  fluid(maxWidth: 650, maxHeight: 350) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const featuredEvents = featuredEventsData.allStrapiFeatured.edges[0].node.events[0];
  return (
    <div className="sliderContainer">
      <EventCard event={featuredEvents} />
    </div>
  );
};
export default FeaturedEvent;
